var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center container-geral"},[_c('div',{staticClass:"container-components"},[_c('Sale',{on:{"getAllSales":function($event){_vm.getAllSales = $event}}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }